module.exports = __webpack_public_path__ + "static/media/vote-yes.2fb5d010.svg";